import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import { navbarBlue } from "../../Classes/theme";
import Navbar, { NAVBAR_SPACE } from "../Navbar/Navbar";
import collage from './collage.webp';
import Ratings from "../Ratings/Ratings";
import PartnersLine from "../PartnersLine/PartnersLine";


export default function Contact() {
    const down = useMediaQuery("(max-width:900px)");

    return (
        <>
            <Navbar logoWhite defaultColor={navbarBlue} />
            <div style={{ width: "100%", height: "150px" }} />
            <Container
                sx={{ color: "black", textAlign: "left", pb: "80px", px: NAVBAR_SPACE, display: 'flex', flexDirection: down ? 'column' : 'row' }}
                maxWidth="lg"
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="blue" sx={{ mb: "18px" }}>Kontakt</Typography>
                    <Typography variant="medium" sx={{}}>Metastream s.r.o.</Typography>
                    <Typography sx={{ opacity: 0.7, mt: '0px', mb: '24px' }}>
                        vedená u Krajského soudu v Brně C113439
                    </Typography>
                    <Typography sx={{ mb: "18px" }}>
                        <b>Sídlo:</b> Högrova 2862/2, Královo Pole, 612 00 Brno<br />
                        <b>IČO:</b> 08393494<br />
                        <b>DIČ:</b> CZ08393494<br />
                    </Typography>
                    <Typography sx={{ mb: "18px" }}>
                        <b>Email:</b> metastream@email.cz<br />
                        <b>DS ID:</b> n3faxrj
                    </Typography>


                    <Typography component={'a'} style={{ textDecoration: 'none', opacity: 0.7, width: 'fit-content' }} href="https://appliner.cz/zasady">Zásady ochrany soukromí</Typography>
                    <Typography component={'a'} style={{ textDecoration: 'none', opacity: 0.7, width: 'fit-content', mt: '12px' }} href="https://appliner.cz/cookies">Zásady cookies</Typography>
                </Box>
                <Box sx={[{
                    mt: down ? '80px' : '20px', pl: { md: '80px', lg: '120px' }, ml: 'auto',
                    display: 'flex', position: 'relative', zIndex: '9', justifyContent: 'center', alignItems: 'center', alignContent: 'center'
                }, down ? { px: '20px' } : {}]}>
                    {<picture>
                        <source srcSet={collage} type="image/webp" />
                        <Box
                            component="img"
                            alt="Ukázka"
                            src={collage}
                            sx={[
                                {
                                    height: 'auto',
                                    maxWidth: '100%',
                                    maxHeight: '500px',
                                    objectFit: 'contain'
                                },

                            ]}
                        />
                    </picture>}
                </Box>

            </Container>
            <Ratings />
            <PartnersLine bgcolor="transparent" />
        </>)
}